import SwitchMerchantPage from '@/views/trade/SwitchMerchantPage'

export default function SwitchMerchant() {
  return <SwitchMerchantPage />
}
